import React from "react";
import { Container, Row, Col, Card, Button, Badge } from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
// import "./offer.css";

const offers = [
  {
    id: 1,
    title: "iPad Pro 2025",
    desc: "Powerful performance with M3 chip. Limited time discount.",
    price: "₹89,999",
    oldPrice: "₹99,999",
    img: "https://images.unsplash.com/photo-1585790050230-5dd28404ccb9",
    discount: "10% OFF",
  },
  {
    id: 2,
    title: "MacBook Air M3",
    desc: "Ultra thin. Ultra fast. Special festival offer.",
    price: "₹1,09,999",
    oldPrice: "₹1,24,999",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8",
    discount: "12% OFF",
  },
  {
    id: 3,
    title: "Apple Watch Series 9",
    desc: "Advanced health tracking & sleek design.",
    price: "₹39,999",
    oldPrice: "₹44,999",
    img: "https://images.unsplash.com/photo-1519741497674-611481863552",
    discount: "15% OFF",
  },
];

const Offer = () => {
  return (
    <div>
      {/* Header */}
      <Header />

      <div style={{ background: "#f4f7fb", minHeight: "100vh" }}>
        {/* 🔷 Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center py-5"
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "#fff",
          }}
        >
          <h1 className="fw-bold">🔥 Mega Apple Offers</h1>
          <p>Grab the best deals on iPad, MacBook & iWatch</p>
        </motion.div>

        {/* 🔷 Offer Cards */}
        <Container className="py-5">
          <Row className="g-4">
            {offers.map((item, index) => (
              <Col xs={12} sm={6} lg={4} key={item.id}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  whileHover={{ scale: 1.05 }}
                >
                  <Card className="shadow border-0 h-100 rounded-4 overflow-hidden">
                    <div style={{ position: "relative" }}>
                      <Card.Img
                        variant="top"
                        src={item.img}
                        style={{
                          height: "250px",
                          objectFit: "cover",
                        }}
                      />
                      <Badge
                        bg="danger"
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          fontSize: "14px",
                        }}
                      >
                        {item.discount}
                      </Badge>
                    </div>

                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="fw-bold">{item.title}</Card.Title>
                      <Card.Text className="text-muted">{item.desc}</Card.Text>

                      <div className="mb-3">
                        <span className="fw-bold fs-5 text-primary">
                          {item.price}
                        </span>
                        <span className="text-muted ms-2 text-decoration-line-through">
                          {item.oldPrice}
                        </span>
                      </div>

                      <Button variant="dark" className="mt-auto rounded-pill">
                        Shop Now
                      </Button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>

        {/* 🔷 Call To Action */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-center py-5"
          style={{ background: "#000", color: "#fff" }}
        >
          <h3 className="fw-bold">Limited Time Offer ⚡</h3>
          <p>Hurry up before the stock runs out!</p>
          <Button variant="warning" size="lg" className="rounded-pill">
            Explore All Deals
          </Button>
        </motion.div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Offer;
